import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import i18next from "i18next";
import logo from "../../../assets/WhatsApp Image 2023-11-29 at 13.24.45_626125bd.jpg";
import LangSelector from "./LangSelector/LangSelector";


const NavTwo = () => {
  const { i18n, t } = useTranslation(["Common"]);

  useEffect(() => {
    if (localStorage.getItem("i18nextLng")?.length > 2) {
      i18next.changeLanguage("en");
    }
  }, []);

  const handellang = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div className=" sticky top-0 z-40 bg-gray-50">
      <header className=" z-30">
        <div className=" z-30 border-b bg-white w-full">
          <div className="px-6 md:px-12 lg:container lg:px-4 m-auto lg:py-2 w-full">
            <div className="flex items-center justify-between">
              <div className=" z-50">
                <img src={logo} className=" h-16 w-36 py-2 lg:px-4" />
              </div>
              <div className="flex items-center  lg:w-[calc(100%-20%)]  justify-end right-0 top-0 border-l-0 lg:border-none">
                <input
                  type="checkbox"
                  name="hamburger"
                  id="hamburger"
                  className="peer"
                  hidden
                />
                <label
                  htmlFor="hamburger"
                  className="peer-checked:hamburger block relative z-40 p-6 -mr-6 cursor-pointer lg:hidden"
                >
                  <div
                    aria-hidden="true"
                    className="m-auto h-0.5 w-6 rounded bg-sky-900 transform transition duration-300"
                  ></div>
                  <div
                    aria-hidden="true"
                    className="m-auto mt-2 h-0.5 w-6 rounded bg-sky-900 transform transition duration-300"
                  ></div>
                </label>
                <div className=" peer-checked:translate-x-0 fixed inset-0 w-[calc(100%-50%)] lg:w-full -z-50 lg:z-40  translate-x-[-100%] bg-white  shadow-xl transition duration-300 lg:blrder-l-0  lg:static lg:shadow-none lg:translate-x-0">
                  <div className="  flex flex-col h-full mt-4 lg:flex-row justify-between lg:justify-around lg:items-center">
                    <ul className=" flex-grow    pt-32 text-gray-700 text-xl font-medium z-50  space-y-3 lg:space-y-0 lg:flex  lg:pt-0">
                      <li className="px-12 lg:px-0 border-t py-2 lg:border-none lg:py-0 w-full lg:text-right cursor-pointer">
                        <Link
                          to="/"
                          className="  cursor-pointer relative   hover:text-orange-700 hover:text-2xl "
                        >
                          {t("Common.Home")}
                        </Link>
                      </li>
                      <li className="px-12 lg:px-0 border-t py-2 lg:border-none lg:py-0 lg:text-right w-full">
                        <Link
                          to="/about"
                          href="#"
                          className="hover:text-2xl  cursor-pointer relative   hover:text-orange-700   "
                        >
                          {t("Common.About")}
                        </Link>
                      </li>
                      <li className="px-12 lg:px-0 border-t py-2 lg:border-none lg:text-right lg:py-0 w-full ">
                        <Link
                          to="/service"
                          href="#"
                          className="hover:text-2xl  cursor-pointer relative   hover:text-orange-700   "
                        >
                          {t("Common.Service")}
                        </Link>
                      </li>
                      <li className="px-12  lg:px-0 border-t py-1 lg:text-right lg:border-none lg:py-0 w-full">
                        <Link
                          to="/gallary"
                          href="#"
                          className=" hover:text-2xl  cursor-pointer relative   hover:text-orange-700   "
                        >
                          {t("Common.Gallery")}
                        </Link>
                      </li>
                      <li className=" px-12  lg:px-0 border-t lg:text-right py-1 lg:border-none lg:py-0 w-full">
                        <Link
                          to="/contact"
                          href="#"
                          className=" hover:text-2xl cursor-pointer relative   hover:text-orange-700   "
                        >
                          {t("Common.Contact")}
                        </Link>
                      </li>
                      <li className=" lg:hidden px-12  lg:px-0 border-t lg:text-right border-b py-3   pb-4 lg:pb-0 lg:border-none  w-full">
                        <LangSelector />
                      </li>
                    </ul>

                    <div className=" z-50 flex flex-shrink-0 flex-row">
                      <div className="cursor-pointer lg:w-50 border-t px-6 md:px-6 py-8 md:py-6 lg:border-none justify-end right-0 top-0 lg:py-0">
                        <a
                          href="#"
                          className=" block  text-center items-center px-6 py-3 rounded-full bg-gradient-to-r from-orange-700 to-orange-400 text-white"
                        >
                          {t("Common.LetsGrow")}
                        </a>
                      </div>
                      {/* ------------ */}
                      <div className=" hidden lg:flex">
                        <LangSelector />
                      </div>

                      {/* ----------- */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default NavTwo;
